const RewardsHowItWorksTempComponent = () => {
  return (
    <>
      <p>
        <strong className="weight-bold">Know how ZeeRewards work:</strong>
      </p>
      <p>
        Welcome to ZeeRewards &ndash; where your loyalty to the Zee5 platform is
        celebrated with thrilling rewards! At Zee, we&apos;re committed to
        enhancing the experience of our loyal viewers by offering exciting
        opportunities to earn rewards and access exclusive benefits.
      </p>
      <p>A world of entertainment &amp; rewards awaits you, Join Now!</p>
      <p>
        <strong className="weight-bold">ZeeCoins Balance:</strong>
      </p>
      <p>
        Keep track of your ZeeCoins, earned through various activities on the
        Zee5 app. These coins can be redeemed for awesome rewards.
      </p>
      <p>
        <strong className="weight-bold">Earning Coins:</strong>
      </p>
      <p>Discover how to earn ZeeCoins:</p>
      <ul>
        <li>
          <strong className="weight-bold">1. Register to Zee5:</strong> Sign up
          to Zee5 to earn 200 ZeeCoins.
          <ul>
            <li>
              <strong className="weight-bold">&#x2022; Steps to follow:</strong>
              <ul>
                <li>a) Click on More menu on home page.</li>
                <li>b) Tap on &lsquo;Login / Register&rsquo;.</li>
                <li>c) Enter your Mobile Number / Email ID.</li>
                <li>d) Verify the OTP.</li>
                <li>
                  e) On successful registration, you will earn 200 ZeeCoins.
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
      <p>
        <strong>&nbsp;</strong>
      </p>
      <ul>
        <li>
          <strong className="weight-bold">2. Join ZeeRewards: </strong>Join
          ZeeRewards to enjoy additional perks and earn 500 ZeeCoins.
          <ul>
            <li>
              <strong className="weight-bold">&#x2022;Steps to follow:</strong>
              <ul>
                <li>
                  a) Click on &lsquo;Join ZeeRewards&rsquo; from the pop-up,
                  banner or from the &lsquo;MyRewards&rsquo; section of
                  Settings.
                </li>
                <li>
                  b) Your registered mobile number or email ID with ZEE5 will be
                  pre-filled.
                </li>
                <li>c) Verify the OTP.</li>
                <li>
                  d) On successfully joining ZeeRewards, you will earn 500 Zee
                  Coins.
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          <strong className="weight-bold">3. Complete User profile: </strong>
          Personalize your profile and earn 250 ZeeCoins.
          <ul>
            <li>
              <strong className="weight-bold">&#x2022; Steps to follow:</strong>
              <ul>
                <li>a) Go to Settings.</li>
                <li>b) Click on your profile.</li>
                <li>c) Tap on Edit.</li>
                <li>d) Add your details and save the changes.</li>
                <li>
                  e) On successful completion of the profile, you will earn 250
                  ZeeCoins.
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          <strong className="weight-bold">
            4. Share videos with friends / family:{' '}
          </strong>
          Spread the joy of Zee5 by sharing videos with friends and family to
          earn 200 Zee Coins.
          <ul>
            <li>
              <strong className="weight-bold">&#x2022; Steps to follow:</strong>
              <ul>
                <li>a) Go to any video that you would like to share.</li>
                <li>b) Tap the &apos;Share&apos; icon.</li>
                <li>
                  c) Select your preferred sharing option and share the video
                  with your friends / family.
                </li>
                <li>
                  d) You will earn 200 Zee coins after sharing videos with 5
                  friends.
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          <strong className="weight-bold">
            5.Refer a friend to subscribe to Zee5:{' '}
          </strong>
          Invite friends to subscribe to Zee5 and earn 500 ZeeCoins per
          successful referral.
          <ul>
            <li>
              <strong className="weight-bold">&#x2022; Steps to follow:</strong>
              <ul>
                <li>
                  a) Click on the &lsquo;More&rsquo; menu on the home page.
                </li>
                <li>b) Tap on &apos;Refer and Earn.&apos;</li>
                <li>c) Click on &apos;Invite now.&apos;</li>
                <li>
                  d) Select your preferred sharing option and refer your friends
                  / family to subscribe to ZEE5.
                </li>
                <li>
                  e) On successful subscription by your friends / family using
                  your code, you will earn 500 ZeeCoins.
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
      <p>&nbsp;</p>
      <ul>
        <li>
          <strong className="weight-bold">6. Watch ILT20 Live matches: </strong>
          Catch the live action of ILT20 matches and earn rewards. The more you
          watch, the more you earn.
          <ul>
            <li>
              <strong className="weight-bold">&#x2022; Steps to follow:</strong>
              <ul>
                <li>
                  a) Click on ILT20 match banners on the homepage or Cricket
                  page.
                </li>
                <li>
                  b) Catch ILT20 Live action by watching the live matches.
                </li>
                <li>
                  c) Earn up to 500 ZeeCoins by watching ILT20 Live matches.
                </li>
                <li>
                  d) The more live cricket you watch, the more ZeeCoins you
                  earn!
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
      <p>&nbsp;</p>
      <p>
        <strong>Note:</strong> Your ZeeCoins balance will be updated within 1-2
        days after you complete any of the steps mentioned above.
      </p>
      <p>
        <strong className="weight-bold">Redeeming Rewards:</strong>
      </p>
      <p>
        Once you&apos;ve collected enough coins, redeem them for exciting
        rewards:
      </p>
      <ul>
        <li>a) Accumulate enough coins to unlock specific rewards.</li>
        <li>b) Click on your desired reward to generate a discount code.</li>
        <li>
          c) Your coins will be deducted from your ZeeCoins balance upon
          redeeming within 1-2 days.
        </li>
        <li>
          d) Keep earning more coins to stand a chance to win Grand prizes!
        </li>
      </ul>
      <p>&nbsp;</p>
      <p>
        <strong>Note: </strong>After redeeming, your vouchers will be sent to
        your email address/phone number within 1-2 days. Additionally, your
        ZeeCoins balance will also be updated within the same timeframe.
      </p>
      <p>
        Join Zee Rewards Today! Don&apos;t miss out on the opportunity to earn
        exciting rewards and enjoy exclusive benefits with ZeeRewards. Start
        earning coins now and unlock a world of entertainment possibilities!
      </p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
    </>
  );
};

export default RewardsHowItWorksTempComponent;
